export { default } from "./getResponseData";
